__turbopack_context__.v({
  "error-message": "media-card-slider-module-scss-module__ijy_Ma__error-message",
  "placeholder": "media-card-slider-module-scss-module__ijy_Ma__placeholder",
  "slider": "media-card-slider-module-scss-module__ijy_Ma__slider",
  "slider-columns-2": "media-card-slider-module-scss-module__ijy_Ma__slider-columns-2",
  "slider-columns-3": "media-card-slider-module-scss-module__ijy_Ma__slider-columns-3",
  "wrapper": "media-card-slider-module-scss-module__ijy_Ma__wrapper",
});
